<div style="margin-left: 265px; background-color: #F8F8F8; padding: 25px;">


  <!-- DASHBOARD SCREEN -->

  <div class="row">

    <div class="col-12 col-lg-6 col-md-6 col-sm-6 col-xl-6 col-xxl-3">
      <div class="card d-flex flex-column position-relative mb-4 text-right card-purchase-open">
        <div class="card-body">
          <div class="align-content-center align-items-center d-flex flex-wrap justify-content-between">

            <div class="pr-2 pr-md-4">
              <h2>Add Grade</h2>
            </div>
            <i class="icon icon-note-add"></i>
          </div>
        </div>
      </div>
    </div>

    <div class="col-12 col-lg-6 col-md-6 col-sm-6 col-xl-6 col-xxl-3">
      <div class="card d-flex flex-column position-relative mb-4 text-right card-buying">
        <div class="card-body">
          <div class="align-content-center align-items-center d-flex flex-wrap justify-content-between">
            <div class="pr-2 pr-md-4">
              <h2>Add Tobacco Type</h2>
            </div>
            <i class="icon icon-buy-crypto"></i>
          </div>
        </div>
      </div>
    </div>

    <div class="col-12 col-lg-6 col-md-6 col-sm-6 col-xl-6 col-xxl-3">
      <div class="card d-flex flex-column position-relative mb-4 text-right card-purchase-sweeping-bale">
        <div class="card-body">
          <div class="align-content-center align-items-center d-flex flex-wrap justify-content-between">
            <div class="pr-2 pr-md-4">
              <h2>Assign Role</h2>
            </div>
            <i class="icon icon-broom"></i>
          </div>
        </div>
      </div>
    </div>

    <div class="col-12 col-lg-6 col-md-6 col-sm-6 col-xl-6 col-xxl-3">
      <div class="card d-flex flex-column position-relative mb-4 text-right card-purchase-close">
        <div class="card-body">
          <div class="align-content-center align-items-center d-flex flex-wrap justify-content-between">
            <div class="pr-2 pr-md-4">
              <h2>Data Upload</h2>
            </div>
            <i class="icon icon-clipboard-close"></i>
          </div>
        </div>
      </div>
    </div>


    <div class="col-12 col-lg-6 col-md-6 col-sm-6 col-xl-6 col-xxl-3">
      <div class="card d-flex flex-column position-relative mb-4 text-right card-dispatch">
        <div class="card-body">
          <div class="align-content-center align-items-center d-flex flex-wrap justify-content-between">
            <div class="pr-2 pr-md-4">
              <h2>User Controls</h2>
            </div>
            <i class="icon icon-clipboard-close"></i>
          </div>
        </div>
      </div>
    </div>

  </div>

  <!-- ASSIGN ROLE SCREEN -->

  <div class="glap-middle-content-wrapperr ">
    <div class="d-flex flex-column h-100">
      <div class="glap-breadcrumb mb-2">
        <div class="row">
          <div class="col-12">
            <h1 class="welcome-title font-size-32">Assign Feature to Role</h1>
          </div>
        </div>
      </div>

      <div class="row gx-4 gy-4">
        <div class="col-sm-12 col-lg-6">
          <form class="glap-middle-form">
            <div class="form-fields">

              <div class="custom-input-wrap">
                <mat-label class="label">Choose Role</mat-label>
                <mat-form-field class="custom-input" appearance="outline">
                  <mat-select placeholder="Select" required>
                    <mat-option value="Buyer">Buyer</mat-option>
                    <mat-option value="Reclassifier">Reclassifier</mat-option>
                    <mat-option value="Voucher-Assisstant">Voucher Assisstant</mat-option>
                    <mat-option value="Warehouse-manager">Warehouse Manager</mat-option>
                    <mat-option value="Admin">Admin</mat-option>
                    <!-- <mat-icon matSuffix color="primary">search</mat-icon> -->
                  </mat-select>
                  <mat-icon matSuffix color="primary" class="icons-font-size">keyboard_arrow_down</mat-icon>
                </mat-form-field>
              </div>

              <div class="custom-input-wrap">
                <mat-label class="label">Employee ID</mat-label>
                <mat-form-field class="custom-input" appearance="outline">
                  <input matInput placeholder="Enter Employee ID" type="number" required>
                  <button matSuffix mat-icon-button>
                    <mat-icon color="primary">search</mat-icon>
                  </button>
                  <!-- <span matSuffix class="weight-suffix"></span> -->
                </mat-form-field>
              </div>


            </div>
          </form>
        </div>
      </div>

      <div class="custom-border"></div>

      <div class="row buying-middle-section gx-4 gy-4">
        <div class="col-sm-12 col-lg-6 ">
          <div class="card h-100">
            <div class="card-header">
              <h3 class="card-title">Employee Information:</h3>
            </div>
            <div class="card-body">
              <div class="row">
                <div class="col-sm-12 col-lg-12">
                  <ul class="list-group mt-0 mb-4">
                    <li class="list-group-item active">Name:<span class="float-end">Kamran Gohar
                      </span> </li>
                    <li class="list-group-item">User ID:<span class="float-end">kgohar</span></li>
                    <li class="list-group-item active">Location:<span class="float-end">EATHAM
                      </span></li>
                    <li class="list-group-item">Division:<span class="float-end">Leaf Division</span></li>
                  </ul>
                </div>
              </div>

            </div>
          </div>
        </div>
      </div>


      <!-- <div
        class="action-buttons-wrapper align-content-center align-items-center d-flex gap-4 justify-content-end mt-auto">
       <button mat-stroked-button class="g-btn g-tertiary-btn" type="button" onclick="window.history.back();" >Cancel</button>
        <button mat-flat-button class="g-btn g-primary-btn">Next</button>
      </div> -->
    </div>
  </div>

  <!-- ADD GRADE SCREEN -->

  <div class="glap-middle-content-wrapperr mt-5">
    <div class="d-flex flex-column h-100">
      <div class="glap-breadcrumb mb-2">
        <div class="row">
          <div class="col-12">
            <h1 class="welcome-title font-size-32">Add Grade</h1>
          </div>
        </div>
      </div>
      <div class="row">
        <div class="col-12 d-inline-flex gap-3">
          <h1 class="mb-4">Purchase Grade & PMI Grade</h1>
          <div
            class="action-buttons-wrapper g-smaller-btn align-content-center align-items-center d-flex gap-4 justify-content-start mt-auto pb-4">
            <button mat-stroked-button class="g-btn g-secondary-btn">Edit Existing Grades</button>
          </div>

          <div
            class="action-buttons-wrapper g-smaller-btn align-content-center align-items-center d-flex gap-4 justify-content-start mt-auto pb-4">
            <button mat-stroked-button class="g-btn g-secondary-btn" (click)="addItemDialog()">Add New Grade</button>
          </div>

        </div>
      </div>


      <div class="row gx-4 gy-4">
        <div class="col-sm-12 col-lg-6">
          <div class="g-custom-table-wrapper mb-5 ">
            <table mat-table class="w-100" [dataSource]="dataSource" matSort
              (matSortChange)="announceSortChange($event)">

              <!-- S No. Column -->
              <ng-container matColumnDef="sNo">
                <th mat-header-cell *matHeaderCellDef mat-sort-header sortActionDescription="Sort by S No"> S No. </th>
                <td mat-cell *matCellDef="let element"> {{element.sNo}} </td>
              </ng-container>

              <!-- PTB Buying Grades Column -->
              <ng-container matColumnDef="ptbGrades">
                <th mat-header-cell *matHeaderCellDef mat-sort-header sortActionDescription="Sort by PTB Buying Grades">
                  PTB Buying Grades </th>
                <td mat-cell *matCellDef="let element">
                  <div class="custom-table-input">
                    <mat-form-field appearance="outline" floatLabel="never">
                      <input matInput [value]="element.ptbGrades" [(ngModel)]="element.ptbGrades">
                    </mat-form-field>
                  </div>

                </td>
              </ng-container>

              <!-- PMI Internal Grades Column -->
              <ng-container matColumnDef="pmiGrades">
                <th mat-header-cell *matHeaderCellDef mat-sort-header
                  sortActionDescription="Sort by PMI Internal Grades">
                  PMI Internal Grades </th>
                <td mat-cell *matCellDef="let element">

                  <div class="custom-table-input">
                    <mat-form-field class="custom-table-input" appearance="outline" floatLabel="never">
                      <input matInput [value]="element.pmiGrades" [(ngModel)]="element.pmiGrades">
                    </mat-form-field>
                  </div>

                </td>
              </ng-container>

              <!-- Action Column -->
              <ng-container matColumnDef="action">
                <th mat-header-cell *matHeaderCellDef> </th>
                <td mat-cell *matCellDef="let element">
                  <button mat-icon-button color="warn" aria-label="Delete record">
                    <mat-icon>delete_outline</mat-icon>
                  </button>
                </td>
              </ng-container>


              <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
              <tr mat-row *matRowDef="let row; columns: displayedColumns;"></tr>
            </table>
            <mat-paginator [pageSizeOptions]="[20, 30, 40]" showFirstLastButtons
              aria-label="Select page of periodic elements">
            </mat-paginator>
          </div>
        </div>
      </div>





    </div>
  </div>


  <!-- TOBACCO TYPE SCREEN -->

  <div class="glap-middle-content-wrapperr ">
    <div class="d-flex flex-column h-100">
      <div class="glap-breadcrumb mb-2">
        <div class="row">
          <div class="col-12">
            <h1 class="welcome-title font-size-32">Add Tobacco</h1>
          </div>
        </div>
      </div>
      <div class="row">
        <div class="col-12 d-inline-flex gap-3">
          <h1 class="mb-4">Add Tobacco Type</h1>
          <div
            class="action-buttons-wrapper g-smaller-btn align-content-center align-items-center d-flex gap-4 justify-content-start mt-auto pb-4">
            <button mat-stroked-button class="g-btn g-secondary-btn">Edit Existing Type</button>
          </div>

          <div
            class="action-buttons-wrapper g-smaller-btn align-content-center align-items-center d-flex gap-4 justify-content-start mt-auto pb-4">
            <button mat-stroked-button class="g-btn g-secondary-btn" (click)="addItemDialog()">Add New Tobacco
              Type</button>
          </div>

        </div>
      </div>


      <div class="row gx-4 gy-4">
        <div class="col-sm-12 col-lg-6">
          <div class="g-custom-table-wrapper mb-5 ">
            <h3>Currently Added Tobacco Types</h3>
            <table mat-table class="w-100" [dataSource]="dataSource2" matSort
              (matSortChange)="announceSortChange($event)">

              <!-- S No. Column -->
              <ng-container matColumnDef="sNo">
                <th mat-header-cell *matHeaderCellDef mat-sort-header sortActionDescription="Sort by S No"> S No. </th>
                <td mat-cell *matCellDef="let element"> {{element.sNo}} </td>
              </ng-container>

              <!-- PTB Buying Grades Column -->
              <ng-container matColumnDef="tobaccoType">
                <th mat-header-cell *matHeaderCellDef mat-sort-header sortActionDescription="Sort by Tobacco Type">
                  Tobacco Type </th>
                <td mat-cell *matCellDef="let element">
                  <div class="custom-table-input">
                    <mat-form-field appearance="outline" floatLabel="never">
                      <input matInput [value]="element.tobaccoType" [(ngModel)]="element.tobaccoType">
                    </mat-form-field>
                  </div>

                </td>
              </ng-container>

              <!-- Action Column -->
              <ng-container matColumnDef="action">
                <th mat-header-cell *matHeaderCellDef> </th>
                <td mat-cell *matCellDef="let element">
                  <button mat-icon-button color="warn" aria-label="Delete record">
                    <mat-icon>delete_outline</mat-icon>
                  </button>
                </td>
              </ng-container>


              <tr mat-header-row *matHeaderRowDef="displayedColumns2"></tr>
              <tr mat-row *matRowDef="let row; columns: displayedColumns2;"></tr>
            </table>
            <mat-paginator [pageSizeOptions]="[20, 30, 40]" showFirstLastButtons
              aria-label="Select page of periodic elements">

            </mat-paginator>
          </div>
        </div>
      </div>





    </div>
  </div>


  <!-- UPLOAD DATA SCREENS -->

  <div>
    <form action="">
      <div class="row pb-2">

        <div class="col-12">
          <h1 class="welcome-title font-size-32">Data Upload</h1>
        </div>

        <div class="col-12 col-lg-4 col-md-4 col-sm-4 col-xl-4">
          <div class="custom-input-wrap">
            <mat-label class="label">Farmer Land/ Yield/ Quota Upload</mat-label>

            <!-- <mat-form-field class="custom-input" appearance="outline">
                    <input matInput placeholder="028661" type="number" required>
                </mat-form-field> -->
            <mat-form-field class="custom-input" appearance="outline" floatLabel="never">
              <input matInput type="file" placeholder="Select File" (change)="onFileSelected($event)" />
              <mat-icon matSuffix class="material-symbols-outlined" color="primary">add_box</mat-icon>
              <!-- <mat-hint>Select File</mat-hint> -->
            </mat-form-field>

          </div>
        </div>

        <div class="col-12">

        <div
            class="action-buttons-wrapper align-content-center align-items-center d-flex gap-4 justify-content-end mt-auto pb-4">
            <button mat-stroked-button class="g-btn g-tertiary-btn" (click)="openSuccessDialog()">Upload</button>
          </div>
        </div>

      </div>
    </form>
    <div class="custom-border"></div>
  </div>

  <!-- SECOND UPLOAD SCREEN -->

  <div>
    <form action="">
      <div class="row pb-2">

        <div class="col-12">
          <h1 class="welcome-title font-size-32">Data Upload</h1>
        </div>

        <div class="col-12 col-lg-4 col-md-4 col-sm-4 col-xl-4">
          <div class="custom-input-wrap">
            <mat-label class="label">Crop Input Advances and Recoveries</mat-label>

            <!-- <mat-form-field class="custom-input" appearance="outline">
                      <input matInput placeholder="028661" type="number" required>
                  </mat-form-field> -->
            <mat-form-field class="custom-input" appearance="outline" floatLabel="never">
              <input matInput type="file" placeholder="Select File" (change)="onFileSelected($event)" />
              <mat-icon matSuffix class="material-icons-outlined" color="primary">add_box</mat-icon>
              <!-- <mat-hint>Select File</mat-hint> -->
            </mat-form-field>

          </div>
        </div>

        <div class="col-12">
          <div
            class="action-buttons-wrapper align-content-center align-items-center d-flex gap-4 justify-content-end mt-auto pb-4">
            <button mat-stroked-button class="g-btn g-tertiary-btn" (click)="openSuccessDialog()">Upload</button>
            <button mat-flat-button class="g-btn g-secondary-btn">Download Template</button>


          </div>
        </div>

      </div>
    </form>
    <div class="custom-border"></div>
  </div>

<!-- User Controls: Location -->

<div class="glap-middle-content-wrapperr ">
  <div class="d-flex flex-column h-100">

    <!-- <div class="glap-breadcrumb mb-2">
      <div class="row">
        <div class="col-12">
          <h1 class="welcome-title font-size-32">Add Tobacco</h1>
        </div>
      </div>
    </div> -->

    <div class="row">
      <div class="col-12 d-inline-flex gap-3">
        <h1 class="mb-4">Location</h1>
        <div
          class="action-buttons-wrapper g-smaller-btn align-content-center align-items-center d-flex gap-4 justify-content-start mt-auto pb-4">
          <button mat-stroked-button class="g-btn g-secondary-btn" (click)="addItemDialog()">Add Location</button>
        </div>

      </div>
    </div>

    <div class="row gx-4 gy-4">
      <div class="col-sm-12 col-lg-6">

        <form class="glap-middle-form">
          <div class="form-fields">

            <div class="custom-input-wrap">
              <mat-label class="label">Location Name</mat-label>
              <mat-form-field class="custom-input" appearance="outline">
                <mat-select placeholder="Select" required>
                  <mat-option value="Charbagh">Charbagh</mat-option>
                  <mat-option value="Chichawatni">Chichawatni</mat-option>
                  <mat-option value="Chilas">Chilas</mat-option>
                  <mat-option value="Cholistan">Cholistan</mat-option>
                  <mat-option value="Chabahar">Chabahar</mat-option>
                  <mat-option value="Chakri">Chakri</mat-option>
                  <mat-option value="Charos">Charos</mat-option>
                  <mat-option value="Chakdara">Chakdara</mat-option>
                </mat-select>
                <mat-icon matSuffix color="primary" class="icons-font-size">keyboard_arrow_down</mat-icon>
              </mat-form-field>
            </div>

            <div class="custom-input-wrap">
              <mat-label class="label">Village Name</mat-label>
              <mat-form-field class="custom-input" appearance="outline">
                <mat-select placeholder="Select" required>
                  <mat-option value="Lahore-Kaly">Lahore Kaly</mat-option>
                  <mat-option value="Lahore-Cantt">Lahore Cantt</mat-option>
                  <mat-option value="Lahore-New">Lahore New</mat-option>
                  <mat-option value="Lahore-East">Lahore East</mat-option>
                  <mat-option value="Lahore-West">Lahore West</mat-option>
                  <mat-option value="Lahore-South">Lahore South</mat-option>
                  <mat-option value="Lahore-North">Lahore North</mat-option>
                  <mat-option value="Lahore-Gora">Lahore Gora</mat-option>
                </mat-select>
                <mat-icon matSuffix color="primary" class="icons-font-size">keyboard_arrow_down</mat-icon>
              </mat-form-field>
            </div>

            <div class="custom-input-wrap">
              <mat-label class="label">Sector Name</mat-label>
              <mat-form-field class="custom-input" appearance="outline">
                <mat-select placeholder="Select" required>
                  <mat-option value="Shakoor">Shakoor</mat-option>
                  <mat-option value="Shahrukh">Shahrukh</mat-option>
                  <mat-option value="Shehroz">Shehroz</mat-option>
                  <mat-option value="Shah Wali">Shah Wali</mat-option>
                  <mat-option value="Shazain">Shazain</mat-option>
                  <mat-option value="Shahzeb">Shahzeb</mat-option>
                  <mat-option value="Shakir">Shakir</mat-option>
                  <mat-option value="Shah Farman">Shah Farman</mat-option>
                </mat-select>
                <mat-icon matSuffix color="primary" class="icons-font-size">keyboard_arrow_down</mat-icon>
              </mat-form-field>
            </div>

            <div class="custom-input-wrap">
              <mat-label class="label">Location Code</mat-label>
              <mat-form-field class="custom-input" appearance="outline">
                <input matInput placeholder="28" formControlName="username">
              </mat-form-field>
            </div>



          </div>
        </form>

      </div>
    </div>



    <div class="row">
      <div class="col-12 d-inline-flex gap-3">
        <h1 class="mb-4">Material</h1>
        <div
          class="action-buttons-wrapper g-smaller-btn align-content-center align-items-center d-flex gap-4 justify-content-start mt-auto pb-4">
          <button mat-stroked-button class="g-btn g-secondary-btn" (click)="addItemDialog()">Add Material</button>
        </div>

      </div>
    </div>

    <div class="row gx-4 gy-4">
      <div class="col-sm-12 col-lg-6">

        <form class="glap-middle-form">
          <div class="form-fields">

            <div class="custom-input-wrap">
              <mat-label class="label">Material Group</mat-label>
              <mat-form-field class="custom-input" appearance="outline">
                <mat-select placeholder="Select" required>
                  <mat-option value="ClipSticks">ClipSticks</mat-option>
                  <mat-option value="CPA">CPA</mat-option>
                  <mat-option value="CPA2">CPA2</mat-option>
                  <mat-option value="Fertilizers">Fertilizers</mat-option>
                  <mat-option value="FuelWood">Fuel Wood</mat-option>
                  <mat-option value="Mechanization">Mechanization</mat-option>
                  <mat-option value="PPEs">PPEs</mat-option>
                </mat-select>
                <mat-icon matSuffix color="primary" class="icons-font-size">keyboard_arrow_down</mat-icon>
              </mat-form-field>
            </div>

            <div class="custom-input-wrap">
              <mat-label class="label">Material Name</mat-label>
              <mat-form-field class="custom-input" appearance="outline">
                <mat-select placeholder="Select" required>
                  <mat-option value="ClipSticks">Clip Sticks</mat-option>
                  <mat-option value="Bifinthrin">Bifinthrin (500ml)</mat-option>
                  <mat-option value="Flumetralin">Flumetralin (500 ml)</mat-option>
                  <mat-option value="NPK">NPK</mat-option>
                  <mat-option value="FuelWood">Fuel Wood</mat-option>
                  <mat-option value="Intercultivator">Intercultivator</mat-option>
                  <mat-option value="cpaGloves">CPA Gloves</mat-option>
                  <mat-option value="emamectinBenzoate">Emamectin Benzoate</mat-option>
                </mat-select>
                <mat-icon matSuffix color="primary" class="icons-font-size">keyboard_arrow_down</mat-icon>
              </mat-form-field>
            </div>

            <div class="custom-input-wrap">
              <mat-label class="label">Sector Name</mat-label>
              <mat-form-field class="custom-input" appearance="outline">
                <mat-select placeholder="Select" required>
                  <mat-option value="Shakoor">Shakoor</mat-option>
                  <mat-option value="Shahrukh">Shahrukh</mat-option>
                  <mat-option value="Shehroz">Shehroz</mat-option>
                  <mat-option value="Shah Wali">Shah Wali</mat-option>
                  <mat-option value="Shazain">Shazain</mat-option>
                  <mat-option value="Shahzeb">Shahzeb</mat-option>
                  <mat-option value="Shakir">Shakir</mat-option>
                  <mat-option value="Shah Farman">Shah Farman</mat-option>
                </mat-select>
                <mat-icon matSuffix color="primary" class="icons-font-size">keyboard_arrow_down</mat-icon>
              </mat-form-field>
            </div>

            <div class="custom-input-wrap">
              <mat-label class="label">Location Code</mat-label>
              <mat-form-field class="custom-input" appearance="outline">
                <input matInput placeholder="28" formControlName="username">
              </mat-form-field>
            </div>



          </div>
        </form>

      </div>
    </div>




  </div>
</div>



</div>
